import { TRequestDto } from '@r1-frontend/api-domru/api-content/v1/cities/tariffs/dto/RequestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Получение пакетов тарифов на продажу
 * {@link https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%AD%D0%BD%D0%B4%D0%BF%D0%BE%D0%B9%D0%BD%D1%82%D1%8B%20%D0%B4%D0%BB%D1%8F%20bundles%20%D0%BF%D0%BE%20%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%83/fe2f1c0bbe63536e8c065ce1cd2baef9 Documentation}
 */
export const tariffs = (queryParams: TRequestDto = {}): IRequest => ({
    uri: '/v1/cities/tariffs',
    method: 'GET',
    queryParams,
    withProvider: true,
});
